import { render, staticRenderFns } from "./OpenCall.vue?vue&type=template&id=2e060264&scoped=true&"
import script from "./OpenCall.js?vue&type=script&lang=js&"
export * from "./OpenCall.js?vue&type=script&lang=js&"
import style0 from "./OpenCall.vue?vue&type=style&index=0&id=2e060264&prod&lang=scss&scoped=true&"
import style1 from "./OpenCall.vue?vue&type=style&index=1&id=2e060264&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e060264",
  null
  
)

export default component.exports